import styled from 'styled-components';

export const ContentStyled = styled.div`
  text-align: left;
`;

export const SubContentStyled = styled.div`
  text-align: left;
  margin-top: 20px;
`;
